import { OperacionLCTCCuentaVista, OperacionLCTCLimiteTipo } from "../types/dto";
import { OperacionLCTCCuentaLimiteFields } from "../types/fields";
import { OperacionLCTC } from "../types/types";
import { OperacionLCTCLimiteFila } from "./OperacionLCTCLimiteFila";

interface OperacionLCTCCuentaFilaProps {
    operacion: OperacionLCTC;
    cuenta: OperacionLCTCCuentaVista;
    loadLimitesOptions: () => Promise<OperacionLCTCLimiteTipo[]>;
    refetch: () => void;
}

const OperacionLCTCCuentaFila = ({ cuenta, operacion, loadLimitesOptions, refetch }: OperacionLCTCCuentaFilaProps) => {
    return (
        <>
            <OperacionLCTCLimiteFila
                key={cuenta.id}
                cuenta={cuenta}
                operacion={operacion}
                loadLimitesOptions={loadLimitesOptions}
                refetch={refetch}
                permiteModificar={cuenta[OperacionLCTCCuentaLimiteFields.PermiteModificar]}
            />
        </>
    );

};

export default OperacionLCTCCuentaFila;
